<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      title="物料条码打印"
      width="700px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="param"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="materialNo" label="物料代码" :rules="$rule.notNull">
            <el-select v-model="param.materialNo" clearable placeholder="请输入物料编码">
              <el-option
                  v-for="item in materialNoList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="number" label="数量" :rules="$rule.notNull">
            <el-input v-model.number="param.number" type="number" min="1" placeholder="请输入数量"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "MaterialBarcodePrintEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        materialNoList: [],
        param: {
          materialNo: "",
          number: "",
        },
        id: "",
      };
    },
    methods: {
      open(selection) {
        this.dialogVisible = true;
        this.id = selection[0].mastPKID;
        selection.forEach((item) => this.materialNoList.push({value: item.partNo, label: item.partNo}));
        console.log(this.id);
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            window.open("http://emes.stepelectric.com/WinOpenASPX/PurchasePrintOne.aspx?PartNo="
              + this.param.materialNo + "&Quantity=" + this.param.number + "&SystemNo=" + this.id);
            this.dialogVisible = false;
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
